import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['form']

  handleNewFilterOptions(event) {
    let name = event.detail.name
    let options = event.detail.options
    let value = event.detail.value
    // options must be a array and name must be a string
    if (options !== undefined && Array.isArray(options) && typeof name === 'string') {
      this.removeInputs(name)
      let inputs = options.map((value) => this.buildInput(name, value))
      this.formTarget.append(...inputs)
      if (event.detail.noSubmit !== true) {
        this.dispatch('reload-form')
      } else {
        this.dispatch('fields-updated', { detail: event.detail })
      }
    } else if (value !== undefined && typeof name === 'string') {
      this.removeInputs(name)
      let input = this.buildInput(name, value)
      this.formTarget.append(input)
      if (event.detail.noSubmit !== true) {
        this.dispatch('reload-form')
      } else {
        this.dispatch('fields-updated', { detail: event.detail })
      }
    }
  }

  removeInputs(name) {
    this.formTarget
      .querySelectorAll(`[name="${name}"]`)
      .forEach(el => el.remove())
  }

  toKebobCase(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
  }

  buildInput(name, value) {
    let input = document.createElement('input')
    input.id = `${this.toKebobCase(name)}-${this.toKebobCase(value)}-input`
    input.type = 'hidden'
    input.name = name
    input.value = value
    return input
  }
}
